import React from "react";
import CompWrapper from "../../hoc/compWrapper/CompWrapper.hoc";
import CardWrapper from "../../hoc/compWrapper/CardWrapper.hoc";
import { Study } from "./component";
export const CurrentResearch = () => {
  return (
    <CompWrapper>
      <CardWrapper>
        <Study />
      </CardWrapper>
    </CompWrapper>
  );
};
